import { useCallback } from "react";

import { INDUSTRY_TAXONOMY_DEMO_ID } from "app/pages/sales-intelligence/modules/industry/constants";
import siNavigator from "app/pages/sales-intelligence/services/siNavigator";
import demoModeTrackingService from "app/pages/sales-intelligence/services/tracking/demo-mode/trackingService";

/**
 * Shared handler for the off-lead-gen offers (home, company analysis) inviting an admin into the demo.
 *
 * These surfaces cannot enter the demo themselves — entry is two-phase and `commitEnteringDemo` is only called by
 * `DemoModeBanner`, which mounts on lead generation alone. Calling `enterDemo` here would strand the session. So the
 * demo id is handed over as a transition param, which the lead-gen page resolves once its filter panel is ready.
 */
export const useEnterIndustryTaxonomyDemo = (): (() => void) => {
    return useCallback((): void => {
        demoModeTrackingService.trackDemoEnterClick(INDUSTRY_TAXONOMY_DEMO_ID);
        void siNavigator.goToAdvancedSearchPage(undefined, { demo: INDUSTRY_TAXONOMY_DEMO_ID });
    }, []);
};
